import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Container } from 'vendors/semantic-ui';

import { routes } from 'config';

import { createPathId, createPath } from 'modules/shared/utils';
import { CMSImageContainerField } from 'modules/shared-cms/cms-base-type';
import { readCMSValue, getDefault } from 'modules/shared-cms/utils';
import { getNestedReferenceId } from 'modules/shared-cms-advanced/utils';
import { Promo, Showroom } from 'modules/shared-cms-advanced/enhanced-blocs';
import { Description } from 'modules/shared-cms-advanced/components';
import { CtaButton, HtmlContainer } from 'modules/shared-ui/components';
import { ImagesViewer } from 'modules/shared-ui-advanced/components';

import { DressProps } from './dress-type';

import enhancer from './dress-enhancer';

import styles from './dress-page.module.css';

const buildCreatorLink = (name: string, id: string): string => {
    if (name && id) {
        return `${routes.laRobe.createurs}/${createPathId(createPath(name), id)}`;
    }
    return '';
};

const InnerDressPage: React.FC<DressProps> = React.memo(
    ({
        brandId: wrappedBrandId,
        titleProduct: wrappedTitleProduct,
        subTitleProduct: wrappedSubTitleProduct,
        subTitleColor: wrappedSubTitleColor,
        productModel: wrappedProductModel,
        productPrice: wrappedProductPrice,
        productDescription: wrappedProductDescription,
        productAdvantage: wrappedProductAdvantage,
        productAdvantageColor: wrappedProductAdvantageColor,
        mentions: wrappedMentions,
        productImgs: wrappedProductImgs,
        productVideoLink: wrappedProductVideoLink,
        firstImg: wrappedFirstImg,
        promo,
        ctaText,

        ...rest
    }: DressProps) => {
        const {
            brandId = getDefault(readCMSValue(wrappedBrandId), ''),
            titleProduct = getDefault(readCMSValue(wrappedTitleProduct), ''),
            subTitleProduct = readCMSValue(wrappedSubTitleProduct),
            subTitleColor = getDefault(readCMSValue(wrappedSubTitleColor), '#000'),
            productModel = readCMSValue(wrappedProductModel),
            productPrice = readCMSValue(wrappedProductPrice),

            productDescription = getDefault(readCMSValue(wrappedProductDescription), ''),
            productAdvantage = getDefault(readCMSValue(wrappedProductAdvantage), ''),
            productAdvantageColor = getDefault(readCMSValue(wrappedProductAdvantageColor), ''),
            mentions = getDefault(readCMSValue(wrappedMentions), ''),
            firstImg = getDefault(readCMSValue(wrappedFirstImg), []),
            productImgs = getDefault(readCMSValue(wrappedProductImgs), []),
            productVideoLink = getDefault(readCMSValue(wrappedProductVideoLink), ''),
            promoId = getDefault(getNestedReferenceId(promo), ''),
            wrappedShowroomId = getDefault(getNestedReferenceId(rest.showroom), ''),
        } = {};
        const imgs = firstImg
            .map((elem: CMSImageContainerField) => {
                const parsedUrl = elem.url.split('?')[0];
                return {
                    url: parsedUrl,
                    fileName: parsedUrl,
                    largeFileName: parsedUrl,
                    thumbnailFileName: parsedUrl,
                };
            })
            .concat(
                productImgs.map((elem: CMSImageContainerField) => {
                    const parsedUrl = elem.url.split('?')[0];
                    return {
                        url: parsedUrl,
                        fileName: parsedUrl,
                        largeFileName: parsedUrl,
                        thumbnailFileName: parsedUrl,
                    };
                }),
            );

        return (
            <React.Fragment>
                <Container>
                    <Grid>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <ImagesViewer
                                varStyleThumb={{ height: '9rem', objectFit: 'cover' }}
                                // varStyleImg={{ maxWidth: '400px', objectFit: 'contain' }}
                                name={`${productModel}`}
                                brandName={`${titleProduct}`}
                                images={imgs}
                                videoUrl={productVideoLink}
                            />
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <div className={styles.title}>
                                <span className={styles.titleName}>
                                    <Link to={buildCreatorLink(titleProduct, brandId)}>{titleProduct}</Link>
                                </span>
                                <span className={styles.subTitleName} style={{ color: subTitleColor }}>
                                    {subTitleProduct}
                                </span>
                            </div>
                            <div className={styles.model}>
                                <span>{productModel}</span>
                            </div>
                            <div className={styles.price}>
                                <span>{productPrice ? `${productPrice} €` : null} </span>
                            </div>

                            <Description small text={productDescription} fontSize={14} textColor="black" />

                            {ctaText ? (
                                <div className={styles.cta}>
                                    <div className={styles.ctaButton}>
                                        <CtaButton ctaText={ctaText} {...rest} forceHover={false} />
                                    </div>
                                </div>
                            ) : (
                                <div className={styles.ctaButton}>&nbsp;</div>
                            )}

                            {productAdvantage ? (
                                <div
                                    className={styles.Advantage}
                                    style={productAdvantageColor ? { backgroundColor: productAdvantageColor } : {}}
                                >
                                    <Description small text={productAdvantage} fontSize={14} textColor="black" />
                                </div>
                            ) : null}
                        </Grid.Column>
                    </Grid>

                    {promoId && (
                        <div className={styles.Promo}>
                            <Promo id={promoId} />
                        </div>
                    )}
                </Container>
                {wrappedShowroomId && <Showroom id={wrappedShowroomId} />}
                {mentions && (
                    <div className={styles.mentions}>
                        <Container>
                            <HtmlContainer htmlContent={mentions} />
                        </Container>
                    </div>
                )}
            </React.Fragment>
        );
    },
);

export const DressPage = enhancer(InnerDressPage);
